import React from 'react'
import { IBadgeProps } from './interfaces'
import { Tooltip } from 'antd'
import { FeatureAnticon } from '../icons/feature-icon'

/**
 * Marks a notification as having been created by a feed, and names the feed in its tooltip.
 *
 * The Feeds icon renders inside antd's `Icon` (`FeatureAnticon`), so it is an `.anticon` like every
 * other badge in a row's strip and shares their baseline shift (`vertical-align: -0.125em`). It is
 * stroke-based, so it takes the row's colour rather than an accent.
 */
export const NotificationFeedBadge: React.FC<IBadgeProps> = (props) => {
    const badge = (
        <span className="icon-feed">
            <FeatureAnticon slot="nav:feeds" aria-hidden="true" />
        </span>
    )

    return (
        <span className="notification-feed-badge">
            {props.hideTooltip ? badge : <Tooltip title={props.tooltip || 'Created from Feed'}>{badge}</Tooltip>}
        </span>
    )
}
